import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import LimitConfigComponent from './LimitConfigComponent';
import { getModel } from './selectors';
import * as actions from './actions';
import * as internalTabActions from '../OperationalParametersV2/SingleChartView/Trend/InternalTabs/actions';
import { withErrorBoundaryTrigger } from 'sharedComponents/ErrorBoundary';

import './style.scss';

const LimitConfigContainer = (props) => {
    return (
        <LimitConfigComponent {...props} />
    );
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return { model };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ ...actions, ...internalTabActions }, dispatch)
    };
};

LimitConfigContainer.propTypes = {
    model: PropTypes.shape({
        timeSeries: PropTypes.shape({
            isLoading: PropTypes.bool, // Whether the time series data is loading
            assetId: PropTypes.string, // Asset ID associated with the time series
        }),
        currentTimeSeries: PropTypes.arrayOf(
            PropTypes.shape({
                uniqId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Unique identifier for the time series
                displayName: PropTypes.string, // Display name of the time series
                isModified: PropTypes.bool, // Whether the time series is modified
                limits: PropTypes.arrayOf(
                    PropTypes.shape({
                        limitValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Value of the limit
                        limitDirection: PropTypes.string, // Direction of the limit
                        limitLevel: PropTypes.string, // Level of the limit
                        isUserLimit: PropTypes.bool, // Whether the limit is user-defined
                    })
                ),
            })
        ),
    }), // Model containing the state data
    actions: PropTypes.shape({
        getLimitKPI: PropTypes.func, // Function to fetch limit KPI data
        getTimeSeries: PropTypes.func, // Function to fetch time series data
        setExpandedSignals: PropTypes.func, // Function to set expanded signals
        setShowLimitSetting: PropTypes.func, // Function to toggle limit settings visibility
        setClickedConfigKpi: PropTypes.func, // Function to set the clicked KPI configuration
        handleSelectTimeSeriesForSuggestion: PropTypes.func, // Function to handle time series selection for suggestions
        handleShowSuggestLimitModal: PropTypes.func, // Function to toggle the suggest limit modal
        getSelectedTimeSeriesSuggestedData: PropTypes.func, // Function to fetch suggested data for the selected time series
    }), // Actions object containing functions
};

const limiConfigContainerConnectWithErrorBoundaryTrigger = withErrorBoundaryTrigger(LimitConfigContainer, {
    excludeErrorCodes: [401, 403, 417]
});
const LimiConfigContainerConnect = connect(
    mapStateToProps,
    mapDispatchToProps
)(limiConfigContainerConnectWithErrorBoundaryTrigger);

export default React.memo(LimiConfigContainerConnect);
